export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Cloudflare ATMB';
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787/api';
export const ENV = import.meta.env.VITE_ENV || 'development';

export const isDevelopment = ENV === 'development';
export const isProduction = ENV === 'production';

export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    DASHBOARD: '/dashboard',
    NOT_FOUND: '/404',
} as const;

export const STORAGE_KEYS = {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    USER_INFO: 'user_info',
} as const;
